import { render, staticRenderFns } from "./permission-microphone.vue?vue&type=template&id=0308525b&"
import script from "./permission-microphone.vue?vue&type=script&lang=js&"
export * from "./permission-microphone.vue?vue&type=script&lang=js&"
import style0 from "./permission-microphone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
})
